export default "__VITE_ASSET__dgRC$HKz__"